<template>
  <transition name="fade">
    <div class="modal-overlay" v-if="visible">
      <div class="modal show" ref="modal" v-draggable>
        <div class="modal-header" ref="header" >
          <span>Drag me!</span>
          <div class="modal-buttons">
            <button @click="$emit('minimize')">-</button>
            <button @click="$emit('update:visible', false)">X</button>
          </div>
        </div>
        <div class="modal-content" v-if="!isMinimized">
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['visible'],
  data() {
    return {
      isMinimized: false,
    };
  },
  watch: {
    visible(newVal) {
      if (!newVal) {
        this.isMinimized = false;
      }
    },
  },
};
</script>

<style scoped>
    .modal-content {
        padding: 15px;
    }
.modal-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0); /* No shadow */
  z-index: 1000;
}

.modal {
  position: absolute;
  width: 900px;
  background-color: white;
  border: 1px solid #e7e7e7;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.08);
  padding: 0px;
  transition: transform 0.3s ease, opacity 0.3s ease;
  transform: scale(0);
  opacity: 0;
  border-radius: 5px;
}

.modal.show {
  transform: scale(1);
  opacity: 1;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  cursor: move;
  padding: 15px;
  margin-bottom: 10px;
}

.modal-buttons button {
  background: none;
  border: none;
  color: black;
  font-size: 16px;
  cursor: pointer;
}

.modal-minimized {
  height: 30px;
  overflow: hidden;
}
</style>



